/* eslint-disable prettier/prettier */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Tooltip,
  Table,
  Thead,
  Tr,
  Th,
  Td,
  Tbody,
  Text,
  Skeleton,
  Checkbox as ChakraCheckbox
} from '@chakra-ui/react'
import { useQuery } from 'react-query'
import React, { useEffect, useState, useCallback } from 'react'
import { FiEdit } from 'react-icons/fi'

import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
  getDocuments,
  useDocumentsServices
} from '../../hooks/documentsServices/useDocumentsServices'
import { useAuth } from '../../hooks/auth'
import { LayoutList } from '../../layouts/List'
import { NotFound } from '../../components/molecules/NotFound'
import { Pagination } from '../../components/PaginationNew'
import { PermissionComponent } from '../../components/Permissions'

// debounce
let timer: any = null

export function DocumentsServices() {
  const { clinicId } = useAuth()
  const [t] = useTranslation('pageDocumentsServices')
  const [searchState, setSearchState] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [isActive, setIsActive] = useState(true)
  const skeletonRepeat = [1, 2, 3, 4, 5, 6, 7]

  const {
    data: getDocumentsData,
    isFetching,
    refetch,
    isLoading
  } = useQuery(
    ['servicesDocuments', String(clinicId), currentPage, searchState, isActive],
    () => getDocuments(String(clinicId), currentPage, searchState, isActive)
  )

  useEffect(() => {
    refetch()
  }, [])

  const SearchInputCallbackValue = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      const { value } = event.currentTarget

      clearTimeout(timer)

      timer = setTimeout(() => {
        setCurrentPage(1)
        setSearchState(value)
      }, 500)
    },
    []
  )

  const ActiveCheckboxCallbackValue = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setIsActive(event.target.checked)
    },
    []
  )

  return (
    <LayoutList
      title={t('title')}
      urlNew="/services/document-service/create"
      refetch={refetch}
      isFetching={isFetching}
      placeholder={t('search')}
      capturaChange={(event: any) => SearchInputCallbackValue(event)}
      captureActiveChange={(event: any) => ActiveCheckboxCallbackValue(event)}
      spiCode="SERVICES_DOCUMENTS"
    >
      <Box>
        <Table variant="striped" colorScheme="blue" size="sm">
          <Thead>
            <Tr>
              <Th>{t('t1')}</Th>

              <Th>{t('t2')}</Th>

              <Th>{t('t4')}</Th>
            </Tr>
          </Thead>
          <Tbody>
            {isLoading ? (
              <>
                {skeletonRepeat.map((skeleton) => (
                  <Tr>
                    <Td>
                      <Skeleton height="20px" />
                    </Td>
                    <Td>
                      <Skeleton height="20px" />
                    </Td>
                    <Td>
                      <Skeleton height="20px" />
                    </Td>
                    <Td>
                      <Skeleton height="20px" />
                    </Td>
                    <Td>
                      <Skeleton height="20px" />
                    </Td>
                  </Tr>
                ))}
              </>
            ) : (
              <>
                {getDocumentsData?.documents !== undefined &&
                  getDocumentsData?.documents.map((doc, index) => (
                    <Tr key={doc.id} maxHeight="40px">
                      <Td>
                        <Text fontSize="sm">{doc.name}</Text>
                      </Td>

                      <Td>
                        <Text fontSize="sm">
                          {doc.actions === 1 && `${t('actions.1')}`}
                          {doc.actions === 2 && `${t('actions.2')}`}
                          {doc.actions === 3 && `${t('actions.3')}`}
                          {doc.actions === 4 && `${t('actions.4')}`}
                        </Text>
                      </Td>

                      <Td>
                        <PermissionComponent
                          spiCode="SERVICES_DOCUMENTS"
                          ipCode="EDIT"
                        >
                          <Link
                            to={{
                              pathname: `/services/document-service/update/${doc.id}`,
                              state: doc
                            }}
                          >
                            <Tooltip
                              label="Editar"
                              aria-label="editar"
                              hasArrow
                              placement="top-start"
                            >
                              <Box ml="1rem" w="24px">
                                <FiEdit
                                  color="#9699B0"
                                  size={16}
                                  style={{ cursor: 'pointer' }}
                                />
                              </Box>
                            </Tooltip>
                          </Link>
                        </PermissionComponent>
                      </Td>
                    </Tr>
                  ))}
              </>
            )}
          </Tbody>
        </Table>
        {getDocumentsData?.totalCountOfPage === 0 && !isLoading && <NotFound />}
      </Box>
      {!(getDocumentsData?.totalCountOfPage === 0 && !isLoading) && (
        <Pagination
          totalCountOfRegisters={getDocumentsData?.totalCountOfPage || 0}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
        />
      )}
    </LayoutList>
  )
}
